// @ts-nocheck
import * as Types from '../../../../__generated/treasury/types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentV2CheckoutMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.TreasuryPaymentsCheckoutInput>;
}>;

export type PaymentV2CheckoutMutation = {
  __typename: 'Mutation';
  treasury?: {
    __typename: 'TreasuryMutation';
    id: string;
    payments?: {
      __typename: 'TreasuryPaymentsMutation';
      checkout?: {
        __typename: 'TreasuryPaymentsCheckoutPayload';
        clientSecret?: string | null;
        error?:
          | {
              __typename: 'TreasuryPaymentsBadRequestError';
              parameter?: string | null;
              message?: string | null;
              details?: string | null;
            }
          | {
              __typename: 'TreasuryPaymentsPaymentError';
              code: Types.TreasuryPaymentsPaymentErrorCode;
              message: string;
            }
          | { __typename: 'TreasuryPaymentsUnauthenticatedError'; message?: string | null }
          | { __typename: 'TreasuryPaymentsUnknownError'; message?: string | null }
          | null;
      } | null;
    } | null;
  } | null;
};

export const PaymentV2CheckoutMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PaymentV2CheckoutMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsCheckoutInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'treasury' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkout' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'error' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PaymentV2ErrorFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PaymentV2ErrorFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsError' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsBadRequestError' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'parameter' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TreasuryPaymentsPaymentError' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type PaymentV2CheckoutMutationMutationFn = Apollo.MutationFunction<
  PaymentV2CheckoutMutation,
  PaymentV2CheckoutMutationVariables
>;

/**
 * __usePaymentV2CheckoutMutation__
 *
 * To run a mutation, you first call `usePaymentV2CheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentV2CheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentV2CheckoutMutation, { data, loading, error }] = usePaymentV2CheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentV2CheckoutMutation(
  baseOptions?: Apollo.MutationHookOptions<PaymentV2CheckoutMutation, PaymentV2CheckoutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PaymentV2CheckoutMutation, PaymentV2CheckoutMutationVariables>(
    PaymentV2CheckoutMutationDocument,
    options
  );
}
export type PaymentV2CheckoutMutationHookResult = ReturnType<typeof usePaymentV2CheckoutMutation>;
export type PaymentV2CheckoutMutationMutationResult = Apollo.MutationResult<PaymentV2CheckoutMutation>;
export type PaymentV2CheckoutMutationMutationOptions = Apollo.BaseMutationOptions<
  PaymentV2CheckoutMutation,
  PaymentV2CheckoutMutationVariables
>;
